import React from 'react';
import { useNavigate } from 'react-router-dom';

export const TABS = [
    { id: 'users', label: 'Users', path: '/user-administration' },
    { id: 'roles', label: 'Roles', path: '/user-administration/roles' },
    { id: 'activity', label: 'Activity log', path: '/user-administration/activity' },
];

/** Title, count, actions and the Users / Roles / Activity log tabs. Each tab renders its own. */
export default function PageHeader({ tab, title, count, sub, actions }) {
    const navigate = useNavigate();
    return (
        <>
            <div className="ua-ph">
                <div>
                    <h1>{title}{count != null ? <span className="ua-count">{count}</span> : null}</h1>
                    <p>{sub}</p>
                </div>
                {actions ? <div className="ua-ph-actions">{actions}</div> : null}
            </div>
            <nav className="ua-tabs" aria-label="User Administration">
                {TABS.map((t) => (
                    <button key={t.id} type="button" aria-current={tab === t.id ? 'page' : undefined} onClick={() => navigate(t.path)}>{t.label}</button>
                ))}
            </nav>
        </>
    );
}
